import React from "react";

const Dot = ({ color = "red" }) => {
  return (
    <div
      className="dot"
      style={{
        backgroundColor: color,
        height: 20,
        width: 20,
        borderRadius: "50%",
      }}
    />
  );
};

export default Dot;
